import { NgModule } from '@angular/core';
import { MinimalLS } from './minimal-localstorage';
var MinimalLSModule = /** @class */ (function () {
    function MinimalLSModule() {
    }
    MinimalLSModule.decorators = [
        { type: NgModule, args: [{
                    providers: [
                        MinimalLS
                    ]
                },] },
    ];
    /** @nocollapse */
    MinimalLSModule.ctorParameters = function () { return []; };
    return MinimalLSModule;
}());
export { MinimalLSModule };
//# sourceMappingURL=ls.module.js.map